import { render, staticRenderFns } from "./BanksConnectionSchoolVersion2.vue?vue&type=template&id=bdf80a80&scoped=true"
import script from "./BanksConnectionSchoolVersion2.vue?vue&type=script&lang=js"
export * from "./BanksConnectionSchoolVersion2.vue?vue&type=script&lang=js"
import style0 from "./BanksConnectionSchoolVersion2.vue?vue&type=style&index=0&id=bdf80a80&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf80a80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdf80a80')) {
      api.createRecord('bdf80a80', component.options)
    } else {
      api.reload('bdf80a80', component.options)
    }
    module.hot.accept("./BanksConnectionSchoolVersion2.vue?vue&type=template&id=bdf80a80&scoped=true", function () {
      api.rerender('bdf80a80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sepay/BanksConnectionSchoolVersion2.vue"
export default component.exports